import { client, adminClient } from "../kanvas-client/index";

export default new (class Auth {
  async login(email: string, password: string) {
    try {
      const response = await client.auth.login(email, password);
      localStorage.setItem("token", response.token);
      return response;
    } catch (err) {
      console.log(err);
    }
  }
  async register({ email, firstName, password }: Record<string, string>) {
    try {
      const res = await client.users.register({
        email: email,
        firstname: firstName,
        lastname: "",
        displayname: "",
        password: password,
        password_confirmation: password,
      });
      localStorage.setItem("token", res.register.token.token);
      return res;
    } catch (err) {
      console.log(err);
    }
  }
  async logout() {
    try {
      const response = await client.auth.logout();
      localStorage.removeItem("token");
      return response;
    } catch (err) {
      console.log(err);
    }
  }
  async resetPassword(email: string, password: string) {
    try {
      const data = await adminClient.app.users.getUserByEmail(email);
      return await adminClient.app.users.updatePassword(data.uuid, password);
    } catch (err) {
      console.error(err);
    }
  }
})();
